import { useState } from 'react';

import { lottieAnimations } from '@backrs_ui/common-ui/src/assets/lottieAnimations';

import { Box, SxProps, Theme } from '@mui/material';
import Lottie from 'lottie-react';

// All share an 800x800 artboard and fill a comparable share of it, so one width suits every one.
const ANIMATION_WIDTH = 220;

const loadingAnimations = [
  lottieAnimations.zigzag,
  lottieAnimations.blob,
  lottieAnimations.teardrop,
  lottieAnimations.cloud,
  lottieAnimations.starburst,
];

type FullScreenLoadingProps = Readonly<{
  /**
   * Fill the nearest sized ancestor rather than the viewport, and inherit its background. For a
   * loader that sits inside page chrome which has to stay visible while it runs.
   */
  fillContainer?: boolean;
}>;

export const FullScreenLoading = ({ fillContainer = false }: FullScreenLoadingProps) => {
  const [animation] = useState(
    () => loadingAnimations[Math.floor(Math.random() * loadingAnimations.length)],
  );

  return (
    <Box sx={fillContainer ? fillContainerSx : fullScreenSx}>
      <Lottie animationData={animation} loop style={{ width: ANIMATION_WIDTH }} />
    </Box>
  );
};

const centeredSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
} as const;

const fullScreenSx: SxProps<Theme> = ({ backrs }) => ({
  ...centeredSx,
  height: '100dvh',
  width: '100dvw',
  backgroundColor: backrs.colors['Beige/25'],
});

const fillContainerSx: SxProps<Theme> = {
  ...centeredSx,
  height: '100%',
  width: '100%',
  flex: 1,
};
